import { Civility } from '../../../../shared/models/customer/type';

export class Subscriptions {
    mariage: boolean = false;

    naissance: boolean = false;

    cadeaux: boolean = false;

    voyage: boolean = false;

    robes: boolean = false;
}

export class Participation {
    civility: Civility = 0;

    firstName: string = '';

    lastName: string = '';

    eventDate?: Date = undefined;

    email: string = '';

    address: string = '';

    complement: string = '';

    phone: string = '';

    city: string = '';

    zipCode: string = '';

    country: string = 'FRANCE';

    subscriptions: Subscriptions = new Subscriptions();
}

export interface GameFormOwnProps {
    onSuccess: (model: Participation) => void;
    textColor?: string;
}

export type GameFormProps = GameFormOwnProps;
